const nl = {
    estateSearch: {
        loading: 'De panden worden geladen...',
        search: 'Zoek',
        emptyFilter: 'Maak filter leeg',
        noResults: 'Sorry we vonden geen resultaten voor uw zoekopdracht.',
        noResultsCTA: 'Niet gevonden wat je zocht?',
        noResultsCTADescription: 'Schrijf je in en ontvang nieuwe panden die met uw zoekcriteria overeenkomen via e-mail',
        noResultsCTAButton: 'Inschrijven',
        cheapestFirst: 'Prijs goedkoopste eerst',
        mostExpensiveFirst: 'Prijs duurste eerst',
        oldestFirst: 'Oudste eerst',
        newestFirst: 'Nieuwste eerst',
        result: 'resultaat',
        results: 'resultaten',
        showMap: 'toon kaart',
        hideMap: 'verberg kaart',
        found: 'gevonden',
        sortBy: 'Sorteer op',
        selected: 'geselecteerd',
    },
};

export { nl };
